import { render, staticRenderFns } from "./circularseal.vue?vue&type=template&id=d5655a5e"
import script from "./circularseal.vue?vue&type=script&lang=js"
export * from "./circularseal.vue?vue&type=script&lang=js"
import style0 from "./circularseal.vue?vue&type=style&index=0&id=d5655a5e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports